interface Route {
  path: string
  activeLink: string
}
export const routes: Record<string, Route> = {
  forgotPassword: {
    path: '/auth/forgot-password',
    activeLink: 'forgot-password',
  },
//  otp: {
 //   path: '/auth/otp',
  //  activeLink: 'otp',

  restPassword: {
    path: '/auth/reset-password',
    activeLink: 'reset-password',
  },
  titleTypesettings: {
    path: '/settings/titlesettings',
    activeLink: 'titleTypesettings',
  },
  login: { path: '/auth/login', activeLink: 'login' },
  adminDashboard: { path: '/admin-dashboard', activeLink: 'admin-dashboard' },

  truckList: { path: '/truck/truck-list', activeLink: 'truck-list' },
  driversList: { path: '/drivers/drivers-list', activeLink: 'drivers-list' },
  fleetList: { path: '/drivers/fleet-list', activeLink: 'fleet-list' },

  driverProfile: {
    path: '/drivers/driver-profile',
    activeLink: 'driver-profile',
  },

  createCheckList: {
    path: '/checklist/create-check-list',
    activeLink: 'create-check-list',
  },
  checkList: { path: '/checklist/check-list', activeLink: 'check-list' },
  checkListDetailView: {
    path: '/checklist/check-list-detail/:transId',
    activeLink: 'check-list-detail',
  },

  truckCheckList: {
    path: '/truck/truck-check-list/:userId/:truckId',
    activeLink: 'truck-check-list',
  },

  companiesAdd: { path: '/customers/company-add', activeLink: 'company-add' },
  vesselList: { path: '/customers/vessel-list', activeLink: 'vessel-list' },
  vesselAdd: { path: '/customers/vessel-add', activeLink: 'vessel-add' },
  settings: { path: '/settings', activeLink: 'settings' },
  settingsLayout: {
    path: '/settings/layout',
    activeLink: 'settings_layout',
  },
  adminAccessRequest: {
    path: '/admin-request-access',
    activeLink: 'admin-request-access',
  },
  // userAccessRequest: {
  //   path: '/user-request-access',
  //   activeLink: 'user-request-access',
  // },
  roleSetting: {
    path: '/setting/role',
    activeLink: 'setting-role',
  },
}
